import { SignOut, X } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import { useAuth } from "common/context/AuthContext";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import type { JSX } from "react";

import AimfoxLogo from "assets/aimfoxLogos/aimfox-logo-text.svg?react";

type OnboardingId = "questionnaire" | "invitation" | "demo" | "webinar";

interface HeaderProps {
  onboardingId: OnboardingId;
  onBack: () => void;
}

export default function Header({ onboardingId, onBack }: HeaderProps) {
  const isDesktop = useTwBreakpoint("lg");
  const { logout } = useAuth();

  let buttonComponent: JSX.Element;
  if (onboardingId === "questionnaire") {
    buttonComponent = isDesktop ? (
      <Button variant="secondary-black" onClick={logout} leftIcon={<SignOut />}>
        Log out
      </Button>
    ) : (
      <Button
        intent="iconOnly"
        size="lg"
        variant="secondary-black"
        onClick={logout}
      >
        <SignOut />
      </Button>
    );
  } else if (onboardingId === "invitation") {
    buttonComponent = isDesktop ? (
      <Button variant="outline-black" onClick={onBack}>
        Leave page
      </Button>
    ) : (
      <Button
        intent="iconOnly"
        size="lg"
        variant="outline-black"
        onClick={onBack}
      >
        <X />
      </Button>
    );
  }

  return (
    <header className="flex h-20 items-center justify-between px-4 bg-white max-lg:shadow-sm relative">
      <AimfoxLogo />
      {buttonComponent}
    </header>
  );
}
